import { getIsDefaultUserBirthday, getIsUserIdentityInsufficient } from "./chunk-PKATHD7C.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Survey.ts

var Survey_exports = {};

__export(Survey_exports, {
  getIsSurveyUserBasicInfoInsufficient: function getIsSurveyUserBasicInfoInsufficient() {
    return _getIsSurveyUserBasicInfoInsufficient;
  }
});

var _getIsSurveyUserBasicInfoInsufficient = function _getIsSurveyUserBasicInfoInsufficient(userData) {
  var weakCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var isIdentityInsufficient = getIsUserIdentityInsufficient(userData);
  var isDefaultUserBirthday = getIsDefaultUserBirthday(userData);

  if (weakCheck) {
    return isIdentityInsufficient || !(userData !== null && userData !== void 0 && userData.birthday) || !(userData !== null && userData !== void 0 && userData.real_name);
  }

  return isIdentityInsufficient || isDefaultUserBirthday || !(userData !== null && userData !== void 0 && userData.real_name);
};

export { _getIsSurveyUserBasicInfoInsufficient as getIsSurveyUserBasicInfoInsufficient, Survey_exports };